import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface HeadingTitleProps {
  children: ReactNode
}

const HeadingTitle = ({ children }: HeadingTitleProps) => {
  return <StyledWrapper>{children}</StyledWrapper>
}

export default HeadingTitle

const StyledWrapper = styled.h1`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.96px;
    color: ${theme.color.text_1};
    font-family: 'GmarketSansMedium';
    white-space: pre-wrap;
    text-align: center;

    & > strong {
      color: ${theme.color.primary_2} !important;
    }
  `}
`
